import React, {  useState } from "react";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import BPAForm26Inbox from "../../BPAForm26Details/Inbox";
import { useParams, useHistory} from "react-router-dom";
import ScheduleInspection from "../../ScheduleInspection/ScheduleInspection";

 const MenuPopupCalender = () =>  {
  const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
 

  const handleClick = (event) => {
    // setAnchorEl(event.currentTarget);
    history.push({
      pathname: `/digit-ui/employee/obps/scheduleInspection`,
    })
  };
  const handleClosePopOver = () => {
    setAnchorEl(false)
  }
  

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        
        <div style={{display:"grid"}}>
        <CalendarMonthIcon style={{margin:"auto"}}/>
        Schedule Inspection
        </div>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClosePopOver}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{zIndex:10000}}
      >
     <MenuItem >
     {/* <ScheduleInspection/> */}
     </MenuItem>
     </Menu>
    </div>
  );
};
export default MenuPopupCalender